import React, { useState , useRef } from "react";
import "./Roof_waterproofing_bituminous_sheets.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר

export default function Roof_tar_and_plastering() {


  return (

    <div className="Roof_waterproofing_bituminous_sheets-page">
      <div className="Roof_waterproofing_bituminous_sheets-hero">
        <div className="Roof_waterproofing_bituminous_sheets-overlay">
          <h1>   זיפות וסיוד גגות</h1>
        </div>
<div>
</div>
</div>
    <div className="page6">
 <div className="breadcrumb6">
  <Link to="/">בית</Link> /{" "}
  <Link to="/OurServices"> השירותים שלנו </Link>/{" "}
   <Link to="/Roof_tar_and_plastering">    זיפות וסיוד גגות </Link>{" "}
</div>
    </div>
    <div className="video-line" />

<div className="video-box2">
  <iframe
    width="100%"
    height="400"
    src="https://www.youtube.com/embed/GeLuOxbSczY?start=11"
    title="YouTube video"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowFullScreen
  ></iframe>
</div>
      {/* CONTENT */}
<div className="page6">
  <div className="container">

    <div className="content-row2">

     <div className="image-box2">
        <img src="/images/16.jpg" alt="roof" />
      </div>
 
      <div className="text-box">
          <h2 className="info-title">   זפת חם נעשה בדרך כלל בבניינים ישנים ובמקומות בהם אין אפשרות לבצע איטום ביריעות.
</h2>
        <p>  


</p>

       <p>  
איטום גגות בזפת חם הוא השיטה הישנה והותיקה ביותר בתחום האיטום.
בזפת חם קיימים סוגים רבים של מוצרי זפת כאשר האיכותי והמתאים ביותר לאקלים בארץ הוא 25/75,
זפת תקני שהיינו ביטומן בדרגת קושי בינונית ללא תוספות של חומרים מינראליים המיועד לאיטום גגות , איטום מרתפים, איטום יסודות, חומר עזר להדבקת יריעות וכו...</p>



       <p>  
הזפת מגיע בחביות, בדלי פח, ובקוביות כאשר בכל אחד מאמצעי האריזה יהיה תווית עם סוג הזפת 25/75 ושם החברה המייצרת (לרוב פזקר)</p>



          <h2 className="info-title">   במידה והזפת לא תקני לא יהיה על החבית שום תיוג.

</h2>
      </div>

    </div>
    <ContactSection2/>
<div className="links2">


  <Link to="/Roof_waterproofing_bituminous_sheets" className="link-right" >   איטום גגות - יריעות ביטומניות </Link>
  <Link to="/Spray_sealing_of_ground_walls" className="link-left" >   איטום קירות תת קרקעים בהתזה / יריעות ביטומניות</Link>


</div>

      </div>
    </div>
  

      </div>
  );
}


